/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiMediaPlacementFromJSON, StreemApiMediaPlacementToJSON, StreemApiMeetingFeaturesFromJSON, StreemApiMeetingFeaturesToJSON, } from './';
export function StreemApiMeetingFromJSON(json) {
    return StreemApiMeetingFromJSONTyped(json, false);
}
export function StreemApiMeetingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'externalMeetingId': !exists(json, 'external_meeting_id') ? undefined : json['external_meeting_id'],
        'mediaPlacement': !exists(json, 'media_placement') ? undefined : StreemApiMediaPlacementFromJSON(json['media_placement']),
        'mediaRegion': !exists(json, 'media_region') ? undefined : json['media_region'],
        'meetingArn': !exists(json, 'meeting_arn') ? undefined : json['meeting_arn'],
        'meetingHostId': !exists(json, 'meeting_host_id') ? undefined : json['meeting_host_id'],
        'meetingId': !exists(json, 'meeting_id') ? undefined : json['meeting_id'],
        'primaryMeetingId': !exists(json, 'primary_meeting_id') ? undefined : json['primary_meeting_id'],
        'meetingFeatures': !exists(json, 'meeting_features') ? undefined : StreemApiMeetingFeaturesFromJSON(json['meeting_features']),
        'tenantIds': !exists(json, 'tenant_ids') ? undefined : json['tenant_ids'],
    };
}
export function StreemApiMeetingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'external_meeting_id': value.externalMeetingId,
        'media_placement': StreemApiMediaPlacementToJSON(value.mediaPlacement),
        'media_region': value.mediaRegion,
        'meeting_arn': value.meetingArn,
        'meeting_host_id': value.meetingHostId,
        'meeting_id': value.meetingId,
        'primary_meeting_id': value.primaryMeetingId,
        'meeting_features': StreemApiMeetingFeaturesToJSON(value.meetingFeatures),
        'tenant_ids': value.tenantIds,
    };
}
//# sourceMappingURL=StreemApiMeeting.js.map